import React from 'react';
import AccountsManagementPage from '../components/accounts/AccountsManagementPage';

const CheckingAccountsPage: React.FC = () => (
  <AccountsManagementPage
    title="Checking Accounts"
    helperText="Manage your checking accounts, including editing and archiving old accounts."
    accountType="checking"
    accountCategory="asset"
  />
);

export default CheckingAccountsPage;
